
$('.js-video-thumbs').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
	  centerMode: false,
	  centerPadding: '0',
    prevArrow: "<a href='#' class='best-sellers-arrow best-sellers-arrow-prev' role='button'><i class='arrow-icon'></i></a>",
    nextArrow: "<a href='#' class='best-sellers-arrow best-sellers-arrow-next' role='button'><i class='arrow-icon'></i></a>",
	responsive: [     
  {
      breakpoint: 1024,
      settings: {
       	slidesToShow: 3,
   		slidesToScroll: 3,
		dots:false,
		arrows:true,
		centerMode: false,
      }
    },
        {
      breakpoint: 768,
      settings: {
       	slidesToShow: 1,
   		slidesToScroll: 2,
		dots:false,
		arrows:false,
		centerMode: false,
      }
    },
    {
      breakpoint: 600,
        centerMode: true,
      	settings: {
        slidesToShow: 1,
		slidesToScroll: 1,
		dots:false,
		arrows:false,
		centerMode: true,
		centerPadding: '60px',

      }
    }
  ]  	
                                 
});
